import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { restaurantSchema, restaurantServiceDataSchema } from './restaurant.schema';
import { ZodError } from 'zod';
import { toast } from 'react-toastify';
import { attachApiErrorToastInterceptor } from '../../utils/api-error-toast';

export const axiosTokenInst = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_RESTUARENT_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosTokenInst);

type UseGetRestaurantsArg = {
  tagId?: number | null;
  name?: string;
};

type Param = {
  page_number: number;
  tag_id?: number;
  items_per_page: number;
  name?: string;
  // is_open:number
};

const GetRestaurants = async ({ signal, pageParam, queryKey }: any) => {
  const params: Param = {
    page_number: pageParam,
    items_per_page: 10,
    // is_open:1,
    ...(queryKey[1] === undefined ? { name: queryKey[2] } : { tag_id: queryKey[1] }),
  };
  try {
    const response = await axiosTokenInst.get('/get-all', { params, signal });
    const parsedata = restaurantServiceDataSchema.parse(response.data);
    return parsedata;
  } catch (error: unknown) {
    if (error instanceof ZodError) {
      console.log(`${process.env.REACT_APP_API_BASE_RESTUARENT_URL}/get-all :`, error?.message);
      toast.error('API validation failed');
    }
  }
};

export const useGetRestaurants = ({ tagId, name }: UseGetRestaurantsArg) => {
  return useInfiniteQuery({
    queryKey: ['get-restaurants', tagId ? tagId : null, name],
    queryFn: GetRestaurants,
    staleTime: 2 * 60 * 1000,
    gcTime: 2 * 60 * 1000,
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      return lastPage?.next_page;
    },
  });
};

type UseGetRestaurantDetailsArg = {
  restaurantId: string;
  enableIf: boolean;
};

export const useGetRestaurantDetails = ({ restaurantId, enableIf }: UseGetRestaurantDetailsArg) => {
  return useQuery({
    queryKey: ['restaurant-details', restaurantId],
    queryFn: async () => {
      try {
        const response = await axiosTokenInst.get(restaurantId);
        console.log(response.data?.data);
        const data = restaurantSchema.parse(response.data?.data);
        return data;
      } catch (error: unknown) {
        if (error instanceof ZodError) {
          console.log(`${process.env.REACT_APP_API_BASE_RESTUARENT_URL}/${restaurantId}: `, error?.message);
          toast.error('API validation failed');
        }
        console.error(error);
      }
    },
    enabled: enableIf,
  });
};

type UseGetRestaurantCategoryArg = {
  restaurantId: string;
  enableIf: boolean;
};
export const useGetRestaurantCategory = ({ restaurantId }: UseGetRestaurantCategoryArg) => {
  return useQuery({
    queryKey: ['restaurant-category', restaurantId],
    queryFn: async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_CATEGORY_URL}/restaurant/${restaurantId}`);
        return response.data;
      } catch (error: unknown) {
        if (error instanceof AxiosError) {
          console.log(
            `${process.env.REACT_APP_API_BASE_CATEGORY_URL}/restaurant/${restaurantId}: `,
            error?.response?.data?.message,
          );
          toast.error(error?.response?.data?.message ?? 'API validation failed');
        }
        console.error(error);
      }
    },
  });
};

export const useGetRestaurantBusinessHours = ({ enableIf, restaurantId }: UseGetRestaurantCategoryArg) => {
  return useQuery({
    queryKey: ['restaurant-business-hour', restaurantId],
    queryFn: async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_SESSION_URL}/business-hour/${restaurantId}`);
        return response.data;
      } catch (error: unknown) {
        if (error instanceof AxiosError) {
          console.log(
            `${process.env.REACT_APP_API_BASE_SESSION_URL}/business-hour/${restaurantId}: `,
            error?.response?.data?.message,
          );
          toast.error(error?.response?.data?.message ?? 'API validation failed');
        }
        console.error(error);
      }
    },
    enabled: enableIf,
  });
};
